import i18next from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { useContext } from 'react';
import { en, es, ptBR } from 'locales';
import { AppContext } from 'appContext';
import { AVAILABLE_LANGUAGES, LOCAL_STORAGE_LANGUAGE_KEY } from 'config/constants';

export const I18nProvider = ({ children }: { children: React.ReactNode }) => {
  const { state } = useContext(AppContext);
  const { user } = state.auth;

  const getLanguageByCountry = (country?: string) => {
    switch (country) {
      case 'Brazil':
        return AVAILABLE_LANGUAGES.PORTUGUESE;
      case 'Mexico':
      case 'Chile':
        return AVAILABLE_LANGUAGES.SPANISH;
      default:
        return AVAILABLE_LANGUAGES.ENGLISH;
    }
  };

  const getLanguageByBrowser = () => {
    switch (true) {
      case /^pt/.test(navigator.language):
        return AVAILABLE_LANGUAGES.PORTUGUESE;
      case /^es/.test(navigator.language):
        return AVAILABLE_LANGUAGES.SPANISH;
      default:
        return AVAILABLE_LANGUAGES.ENGLISH;
    }
  };

  i18next.use(initReactI18next).init({
    resources: { en, es, 'pt-BR': ptBR },
    lng: user
      ? localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) || getLanguageByCountry(user.country)
      : localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) || getLanguageByBrowser(),
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'lowercase') return value.toLowerCase();
        if (format === 'capitalize') return value.replace(/^\w/, (c: string) => c.toUpperCase());
        return value;
      },
    },
  });

  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
};

export const i18n = i18next;
